/**
 * 商品企画マスタ画面　商品選定VOクラス
 */
export class KYMW1300RegistPlanModel {

  public mediumType: string = null;                                             // 媒体区分
  public sellAreaCode: string = null;                                           // 売り場コード
  public orderNumQuotaCode: string = null;                                      // 注文コード割当コード
  public featureCode: string = null;                                            // 特集コード
  public bundleCatalogRoundId: string = null;                                   // 束ね企画回ID
  public orderCodeList: Array<string> = new Array<string>();                    // 受注コードリスト
  public pCodeList: Array<string> = new Array<string>();                        // Ｐコードリスト

}
